@reference "@glow/tailwind-config/reference.css";

.radio {
  @apply inline-block;
  @apply relative;
  @apply w-5;
  @apply h-5;
  @apply select-none;
}

.radio input {
  @apply absolute;
  @apply inset-0;
  @apply opacity-0;
  @apply appearance-none;
  @apply cursor-pointer;
}

.radio input + span {
  @apply block;
  @apply absolute;
  @apply inset-0;
}

.radio input:focus + span,
.radio input:focus-visible + span {
  @apply outline;
  @apply outline-2;
  @apply outline-primary-500;
}

.radio input + span svg {
  @apply absolute;
  @apply inset-0;
  @apply m-auto;
  @apply text-emphasis-ultra;
}

.disabled {
  @apply opacity-30;
}
